export default __webpack_public_path__ + "static/media/broomfield-openspaces.064cc4f0.woff2";